import axios from "axios";
import {
  refreshTokenFailure,
  refreshTokenStart,
  refreshTokenSuccess,
} from "../containers/Auth/auth.reducer";
const appKey = process.env.REACT_APP_API_KEY;
const sessionID = localStorage.getItem("sessionID");

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["XAPIKey"] = appKey;

axios.defaults.headers.common["Authorization"] = "Bearer " + sessionID;

export const addSessionToken = (sessionID) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + sessionID;
};

// Function to refresh the token
let isRefreshing = false;
let refreshSubscribers = [];

const refreshToken = () => async (dispatch) => {
  dispatch(refreshTokenStart());
  localStorage.setItem("refreshTokenLoading", JSON.stringify(true));
  try {
    const response = await axios.post(
      "/api/Auth/refresh-token",
      {
        refreshToken: localStorage.getItem("refreshToken"),
      },
      {
        validateStatus: (status) => status < 505, // Ensure errors are caught
      }
    );
    if (response.status !== 200) {
      dispatch(refreshTokenFailure());
      localStorage.setItem("refreshTokenLoading", JSON.stringify(false));
      return null;
    }
    if (response) {
      if (response.data) {
        dispatch(refreshTokenSuccess());
        localStorage.setItem("refreshTokenLoading", JSON.stringify(false));
        const {
          accessToken,
          accessJobbing,
          refeshToken,
          accountType,
          userType,
          stockLocationName,
          boahubLocationId,
          relatedCompanyLogoUrl,
          relatedCompanyId,
          defaultAssetCategory,
          boahubFindPod,
          boahubIsRS23,
          isBoahubPremium,
          boahubBuildDigitalTwin,
          premiumActivatedAt,
          showPP,
          showRRP,
          isJobbingBasicMode,
        } = response.data;
        if (accessToken && refeshToken) {
          addSessionToken(accessToken);
          window.localStorage.setItem("sessionID", accessToken);
          window.localStorage.setItem("accessJobbing", accessJobbing);
          window.localStorage.setItem("refreshToken", refeshToken);
          window.localStorage.setItem("accountType", accountType);
          window.localStorage.setItem("userType", userType);
          window.localStorage.setItem("stockLocationName", stockLocationName);
          window.localStorage.setItem("boahubLocationId", boahubLocationId);
          window.localStorage.setItem(
            "relatedCompanyLogoUrl",
            relatedCompanyLogoUrl
          );
          window.localStorage.setItem("companyId", relatedCompanyId);
          window.localStorage.setItem(
            "defaultAssetCategory",
            defaultAssetCategory
          );
          window.localStorage.setItem("boahubFindPod", boahubFindPod);
          window.localStorage.setItem("boahubIsRS23", boahubIsRS23);
          window.localStorage.setItem("isBoahubPremium", isBoahubPremium);
          window.localStorage.setItem(
            "boahubBuildDigitalTwin",
            boahubBuildDigitalTwin
          );
          window.localStorage.setItem("premiumActivatedAt", premiumActivatedAt);
          window.localStorage.setItem("boahubShowPurchasePrice", showPP);
          window.localStorage.setItem("boahubShowRrp", showRRP);
          window.localStorage.setItem("isJobbingBasicMode", isJobbingBasicMode);

          if (accountType === 1 || accountType === "1") {
            window.localStorage.setItem("accessJobbing", "true");
          } else {
            window.localStorage.setItem("accessJobbing", "false");
          }

          return accessToken;
        }
      }
    }
    return null;
  } catch (error) {
    dispatch(refreshTokenFailure());
    localStorage.setItem("refreshTokenLoading", JSON.stringify(false));
    console.error("Refresh token failed", error);
    return null;
  }
};

// Queue requests while refreshing
const subscribeTokenRefresh = (callback) =>
  new Promise((resolve, reject) => {
    refreshSubscribers.push({ resolve, reject, callback });
  });

// Notify all subscribers after refresh
const processSubscribers = (token, error = null) => {
  refreshSubscribers.forEach(({ resolve, reject, callback }) => {
    error ? reject(error) : (callback(token), resolve());
  });
  refreshSubscribers = [];
};

// Clone request with all properties
const cloneRequest = (request) => ({
  ...request,
  headers: { ...request.headers },
  data: request.data,
  _retry: true,
});

// Request Interceptor - Attach Access Token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("sessionID");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor - Handle 401 Errors
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Bypass refresh logic if the API is `/login`
    if (originalRequest.url.includes("/login")) {
      return Promise.reject(error);
    }

    // Ensure it's a 401 and hasn't been retried
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await (window.store
            ? window.store.dispatch(refreshToken())
            : refreshToken());

          // Retry the first failed request immediately
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          const firstRetry = await axios(cloneRequest(originalRequest));

          // Process all other pending requests
          processSubscribers(newToken);
          return firstRetry;
        } catch (refreshError) {
          processSubscribers(null, refreshError);
          localStorage.clear();
          window.location.href = "/";
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      // Queue subsequent requests
      try {
        await subscribeTokenRefresh((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
        });

        return axios(cloneRequest(originalRequest));
      } catch (subError) {
        return Promise.reject(subError);
      }
    }

    return Promise.reject(error);
  }
);
